import { lazy } from 'react';

const NotFound = lazy(() => import('./NotFound'));

export default NotFound;
